import * as React from 'react';
import Switch, { SwitchProps } from '@mui/material/Switch';
import { styled } from '@mui/material';

interface ControlledSwitchesProps extends SwitchProps {
    // You can add custom props here if needed
}
const MaterialUISwitch = styled(Switch)(() => ({
    '& .MuiSwitch-switchBase': {
        '&.Mui-checked': {
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: ' #D7172F',
            },
        },
    },
    '& .MuiSwitch-thumb': {
        backgroundColor: '#FFFFFF',
    },
}));
export default function SwitchButton(props: ControlledSwitchesProps) {
    return <MaterialUISwitch {...props} inputProps={{ 'aria-label': 'controlled' }} />;
}
